"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Setting = exports.Control = void 0;
var Setting = exports.Setting = /*#__PURE__*/function (Setting) {
  Setting["disallowUnmute"] = "DisallowUnmute";
  Setting["muteOnEntry"] = "MuteOnEntry";
  Setting["muted"] = "Muted";
  Setting["roles"] = "Roles";
  return Setting;
}(Setting || {});
var Control = exports.Control = /*#__PURE__*/function (Control) {
  Control["audio"] = "audio";
  Control["raiseHand"] = "raiseHand";
  Control["reactions"] = "reactions";
  Control["shareControl"] = "shareControl";
  Control["video"] = "video";
  Control["viewTheParticipantList"] = "viewTheParticipantList";
  return Control;
}(Control || {});
var _default = exports.default = Setting;
//# sourceMappingURL=enums.js.map
